import { Box, Divider, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import BackButton from '../components/Buttons/BackButton';
import FilmOfficeStepsComp from '../components/FormContainers/FilmOffice/FilmOfficeStepsComp';
import FormSkeleton from '../components/Skeletons/FormSkeleton';
import { eliminateOjectNotTruthyValues } from '../lib/helperFuncs';
import HttpService from '../services/HttpService';
import Theme from '../Themes/main.theme';
import { ICreateFO } from './Admin/AddFilmOffice';

const EditFilmOffice = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const {t} = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [data, setData] = useState<ICreateFO>();

  const getData = async () => {
    try {      
      const response = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/registrations/film_office/${id}`);
      setData({...response.data, regions: response.data.region.value});
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const onSubmit = async (values: ICreateFO) => {
    setIsLoading(true);
    try {      
      const response = await HttpService.getAxiosClient().patch(`${process.env.REACT_APP_BACKEND_URL}/registrations/film_office/${id}`, 
        eliminateOjectNotTruthyValues({...values})
      );
      if (response.status === 200){
        navigate('/admin/units/dashboard');
        enqueueSnackbar(`Επιτυχής Επεξεργασία του Film Office: ${response.data.title}`, { variant: 'success' });
      } 
    } catch (error) {
      enqueueSnackbar('Η Επεξεργασία Film Office απέτυχε, παρακαλώ προσπαθήστε ξανά ή επικοινωνήστε με τον διαχειριστή σας!', { variant: 'error' });
      console.error(error);
    }
    setIsLoading(false);
  };

  return (
    <>
      <Box mt={2} mb={2}>
        <BackButton onClick={() => navigate(-1)}/>
      </Box>
      <Typography variant='h2'
        color={Theme?.labelColor?.main}>{t('Επεξεργασία Film Office')}</Typography>
      <Divider sx={{mb: 5, mt: 2, border: 1, color: Theme?.dividerColor?.main}}/>
      {data
        ? <FilmOfficeStepsComp
          isLoading={isLoading}
          initialValues={data} 
          onSubmit={onSubmit}
          edit/>
        : <FormSkeleton lines={6}/>
      }
    </>
  );
};

export default EditFilmOffice;